import { onBeforeUnmount, onMounted, ref } from "vue";

// Spring config konsisten untuk seluruh scroll-reveal situs
const SPRING = { type: "spring", stiffness: 180, damping: 18, mass: 0.75 };

export function useMotionVariants() {
  const prefersReducedMotion = ref(false);
  let query = null;

  const update = (e) => {
    prefersReducedMotion.value = e.matches;
  };

  onMounted(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    query = window.matchMedia("(prefers-reduced-motion: reduce)");
    prefersReducedMotion.value = query.matches;
    if (query.addEventListener) query.addEventListener("change", update);
    else query.addListener(update);
  });

  onBeforeUnmount(() => {
    if (!query) return;
    if (query.removeEventListener) query.removeEventListener("change", update);
    else query.removeListener(update);
  });

  function motionVariant(y = 20, x = 0, delay = 0) {
    if (prefersReducedMotion.value) {
      return { opacity: 1, y: 0, x: 0, transition: { duration: 0 } };
    }
    return {
      opacity: y === 0 && x === 0 ? 1 : 0,
      y,
      x,
      transition: { ...SPRING, delay },
    };
  }

  // Reveal butir list dengan jeda base + i*step (default 60ms sesuai MD stagger)
  function staggered(index, base = 0, step = 0.06) {
    return motionVariant(0, 0, base + index * step);
  }

  return { prefersReducedMotion, motionVariant, staggered };
}
